import Communications from 'react-native-communications';
import { action, observable, runInAction, toJS } from 'mobx';
import objectKeyCheck from '../../Utils/objectKeyCheck';
import * as loginUtil from '../../Utils/loginUtil';
import getClientJson from '../../Utils/getClientJson';
import invalidLoginCodeMap from '../../Constant/invalidLoginCodeMap';
import * as orderCache from './orderCache';
import { RootStoreInterface } from '../../Store/index';
// import QImageSet from '../../../../../assets/QImageSet';
import QImageSet from '../../assets/QImageSet';
import URLS from '../../Constant/urls';
import { toast } from '../../Utils/toast';
import { fetch } from '../../Utils/fetch';
import { navigate } from '../../Utils/navigate';
import { qav } from '../../Utils/qav';
import { NoDataTypes } from './NoDataTypes';
import { SearchResultStoreModel } from '../../Store/SearchResult/index';
// export const NPM_ORDER_VERSION = 8;// 定义NPM组件的版本，供后端做版控使用
export const CLIENT_VERSION = 1;// 添加接口版本号，1-机票合单
import f from '@qnpm/react-native-ext-fetch';
import PPLogUtil, { OPER_CLICK } from '../../Utils/PPLogUtil';
import {Platform} from "react-native";
import {DeviceInfo, Toast} from "qunar-react-native";
import Util from "../../Utils/util";
import { QToast } from '@qnpm/q-components';
import getQueryParam from '../../Utils/getQueryParam';

const {isWeb,isMini,isIOS,isAndroid} = DeviceInfo;
const { fixWxOrderUrl,getBizVersion } = Util;

export default class OrderList {
    public pageName = '';

    // 每页多少条订单
    public pageSize = 10;

    // 请求url
    public url = '';

    // 请求方法
    public method = 'GET';

    public ordertoken: any;

    public orderSource: any;

    // 请求参数
    public requestParams: any = {};

    // 额外请求参数
    public extraRequestParams = {};

    // 请求超时
    public timeout = 10000;

    // 下一页的开始数
    public nextStart = 0;

    // 停止之前的请求
    public abort: () => any = null;

    public orderNo = '';
    public sysCode = '';
    public orderCellIndex = -1;

    // 还有更多
    @observable
    public hasMore = false;

    // 加载更多是否成功
    @observable
    public loadmoreSuc = true;

    // 正在加载中
    @observable
    public inLoading = 0;

    // 开启删除功能
    @observable
    public enableDelete = false;

    @observable
    public originDataSource: any[] = [];

    // 订单数据源
    @observable
    // dataSource = ds.cloneWithRows([]);
    public dataSource: any[] = [];

    //
    @observable
    public combinationIdAry: any[] = [];

    @observable
    public needScrollTopAndRefresh = 0;

    @observable
    public needStopRefresh = 0;

    @observable
    public needStopLoadMore = 0;

    // 是否有网
    @observable
    public isNetworkConnect = true;

    // 首次加载
    public firstLoaded = false;

    public toggleLoadmoreTimer: NodeJS.Timeout = null;

    // 是否展示右下角的回到顶部按钮
    @observable
    public showBackToTop: any;

    // 需要发送qav性能埋点
    public needPerfQavLog = false;

    // 是否需要请求快捷服务按钮列表
    public needFetchSeriveBtn = false;

    public initCallback: any;

    public useCache: boolean;
    public onLoginInvalid: () => void;
    public onNetworkError: () => void;
    public onDataLoaded: any;
    public onloginSuc: () => void;
    public initCallbackCreator: any;
    public scrollToTop: any;

    public rootStore: RootStoreInterface | SearchResultStoreModel;

    @observable
    public showNoData = false;

    @observable
    public isLogin = false;

    @observable
    public type: NoDataTypes;

    @observable
    public noDataFlag = false;

    @observable
    public alertVisible = false;

    @observable
    public alertTitle = '';

    @observable
    public cofirmVisible = false;

    @observable
    public privateVisible = false;

    @observable
    public privateCallback = ()=>{};
    
    // 展示加载更多
    @observable
    public showLoadMore = false;

    // 卡片服务AB分桶,A走线上,B走新样式
    public abSlotId = 'A';

    // 用户摇一摇输入的隐藏订单密码
    public privateOrderWord = '';

    // 是否需要展示Toast
    public isNeedShowShakeToast = false;

    // 是否从隐藏订单返回
    public isBackFromPrivateOrder = false;

    // 是否支持业务线隐私订单
    public supportPrivateOrder = false;

    // 是否正在使用缓存订单
    public usingCacheData = false;

    // 要删除的订单信息
    public deleteInfo: {
        isShare?: boolean;
        sysCode?: string;
        orderNo?: string;
        canDelete: boolean;
        deleteTip: string;
    } = null;

    // 停止之前的请求
    public abortDelete: () => any = null;


    @observable
    public serviceBtnList: any[] = [];

    public itemsShowing: any[] = [];

    public constructor(
        opts: {
            pageName: string;
            pageSize: number;
            url: string;
            method: string;
            useCache: boolean;
            needPerfQavLog?: boolean;
            needFetchSeriveBtn?: boolean;
            ordertoken?: any;
            orderSource?: any;
            onNetworkError(): void;
            onDataLoaded(loadType: string, data?: any): Promise<void>;
            onloginSuc?(): void;
            initCallbackCreator(a: boolean, b: boolean): void;
            onLoginInvalid?(): void;
        },
        rootStore: RootStoreInterface | SearchResultStoreModel
    ) {
        const validKeys = [
            'pageName',
            'pageSize',
            'url',
            'method',
            'ordertoken',
            'orderSource',
            'useCache',
            'needPerfQavLog',
            'onLoginInvalid',
            'onDataLoaded',
            'onNetworkError',
            'onloginSuc',
            'initCallbackCreator',
            'needFetchSeriveBtn',
        ];

        // opts key 校验
        if (!objectKeyCheck(opts, validKeys)) {
            throw Error(`初始化orderlist失败，只能传入一下key值${validKeys.join(',')}`);
        }

        const {
            pageName,
            pageSize = 15,
            url = '',
            method = 'GET',
            ordertoken,
            orderSource,
            useCache,
            needPerfQavLog,
            needFetchSeriveBtn,
            onLoginInvalid = () => {},
            onNetworkError = () => {},
            onDataLoaded = () => {},
            onloginSuc = () => {},
            initCallbackCreator
        } = opts;

        this.pageName = pageName;
        this.pageSize = pageSize;
        this.url = url;
        this.method = method;
        this.ordertoken = ordertoken;
        this.orderSource = orderSource;
        this.useCache = useCache;
        this.needPerfQavLog = needPerfQavLog;
        this.onLoginInvalid = onLoginInvalid;
        this.onNetworkError = onNetworkError;
        this.onDataLoaded = onDataLoaded;
        this.onloginSuc = onloginSuc;
        this.initCallbackCreator = initCallbackCreator;
        this.needFetchSeriveBtn = needFetchSeriveBtn;

        this.rootStore = rootStore;
    }

    public changeShowingItems = (showingItems=[]) => {
        this.itemsShowing = showingItems;
        // 判断服务按钮是否需要show埋点
        this.itemsShowing.map(item=>{
            const res = this.serviceBtnList.find(serviceItem=>{
                return serviceItem?.hasShowed !== true && serviceItem?.orderNo === item?.item?.orderNo;
            })
            if (res) {
                const {imButton:{
                    actionList=[],
                    robotUrl='',
                }={}, } = res;
                const cardData = item.item? item.item: {};
                const {businessType} = cardData

                if (this.dataSource.indexOf(cardData) === -1) {
                    return;
                }

                res.hasShowed = true;
                actionList.map((serviceBtn, index)=>{
                    if (this.dataSource.indexOf(cardData) === -1) {
                    }
                    PPLogUtil.logForQuickService({
                        businessType,
                        cardPosition: String(this.dataSource.indexOf(cardData)),
                        position: String(index),
                        title: serviceBtn.actionName,
                        operType: 'show',
                    })
                })
                if (Boolean(robotUrl)) {
                    PPLogUtil.logForQuickService({
                        businessType,
                        cardPosition: String(this.dataSource.indexOf(cardData)),
                        title: '客服',
                        operType: 'show',
                    })                }
            }
        })
    }

    @action
    public changeDataSource = ({ newDataSource, append }: any) => {
        if (append) {
            this.originDataSource = this.originDataSource.concat(newDataSource);
        } else {
            this.originDataSource = newDataSource;
        }
        // this.dataSource = ds.cloneWithRows(toJS(this.originDataSource));
        this.dataSource = this.originDataSource;

        // setTimeout(() => {
        //     this.originDataSource[2].statusDesc = '临时测试22222'
        //     this.dataSource = this.originDataSource.slice();
        //     // console.log('^^^^^^&&&&&'+JSON.stringify(this.dataSource))
        // }, 2000);

        //发送服务按钮请求
        this.fetchServiceData(newDataSource, append);

        // 如果列表刷新,则隐藏掉正在展示的按钮弹窗
        if (!append) {
            this.rootStore.moreButtonStore && this.rootStore.moreButtonStore.hiddenMoreButtonList();
        }
    };

    @action
    public toggleNetworkConnect = (isNetworkConnect: boolean) => {
        if (this.rootStore.actived) {
            if (!this.isNetworkConnect && isNetworkConnect) {
                if (this.firstLoaded) {
                    this.scrollTopAndInit();
                }
            } else if (this.isNetworkConnect && !isNetworkConnect) {
                // if(this.rootStore.uiState.isJourneyInnerModule && this.rootStore.uiState.currentSelectedIndex === 0){

                // }else{
                    toast({
                        msg: '网络不太顺畅，您访问的是缓存订单'
                    });
                // }
            }
        }
        this.isNetworkConnect = isNetworkConnect;
    };

    // 初始化 或者 切换筛选栏 或者 切换状态栏
    @action
    public scrollTopAndInit = (isCold = true, isFirstLoad?: boolean) => {
        this.needScrollTopAndRefresh++;
        this.initCallback = this.initCallbackCreator
            ? this.initCallbackCreator(isCold, isFirstLoad)
            : undefined;
    };

    @action
    public init = async (type = 'init') => {
        this.nextStart = 0;
        this.hasMore = false;
        this.loadmoreSuc = true;
        this.toggleShowLoadMore(false);
        const isLogin = Boolean(await loginUtil.isLogin());
        this.toggleDeleteable(isLogin);

        const cb = this.initCallback
            ? this.initCallback
            : this.initCallbackCreator
            ? this.initCallbackCreator()
            : undefined;
        this.initCallback = undefined;
        this.fetchData(type, cb);
    };

    // 上拉加载
    public loadMore = () => {
        this.fetchData('loadMore');
    };

    //请求服务按钮
    public  fetchServiceData = async (dataSource: any[], append: boolean, cb = () => {})=>{
        if(Platform.OS !== 'android' && Platform.OS !== 'ios'){
            return
        }
        if (!this.needFetchSeriveBtn) {
            return;
        }
        if (!dataSource || dataSource.length === 0) {
            if (append) { // 这种情况是强刷为空列表,按钮数组都清空
                this.serviceBtnList = [];
            }
            return;
        }
        const orderInfos: { sysCode: any; orderNo: any; }[] = [];
        dataSource.forEach(item => {
            if(item.flightMerge){
                item.listData.forEach((v:any) => {
                    orderInfos.push({
                        sysCode: v.sysCode,
                        orderNo: v.orderNo,
                    });
                })
            }else{
                orderInfos.push({
                    sysCode: item.sysCode,
                    orderNo: item.orderNo,
                });
            }
        })

        let clientJson,extMap;
        try {
            clientJson = await getClientJson(this.rootStore.hyId || 'cmn_order_rn');
            extMap = await getBizVersion('hotel_rn');
            clientJson.extMap = extMap;
        } catch (err) {
            clientJson = {};
        }
        // clientJson.uid = 'BAE9EC71-8037-46DC-B83C-1B622526A8ED';

        const body = {
            orderInfos,
            loginQuery: true,
            clientJson,
        }
        // console.log('body',JSON.stringify(body))
        try {
            const response = await f(
                {
                    url: URLS.serviceAction,
                    method: 'POST',
                    body,
                }
            );
            // console.log("serviceAction=====",JSON.stringify(response))
            if (!Array.isArray(response?.data?.dynamicResultList)) {
                return;
            }
            
            if (append) {
                this.serviceBtnList = this.serviceBtnList.concat(response.data.dynamicResultList).slice()
            } else {
                this.serviceBtnList = response.data.dynamicResultList;
            }
            
            // 处理show事件
            this.changeShowingItems(this.itemsShowing);

        } catch (error) {
            // alert(error.message);
        }

    }


    // 开始请求数据
    @action
    public fetchData = async (loadType: string, cb = () => {}) => {
        
        if (loadType === 'init') {
            const response =  await orderCache.getFirstScreenCache(this.rootStore);
            if (response) {
                const fetchSuccessParams: FetchSuccessParams = {
                    response,
                    loadType,
                    cb,
                    curStart:0,
                    fromCache: true
                };
                this.fetchSuccess(fetchSuccessParams);
                this.usingCacheData = true;
                this.init('refresh');
                return;
            }
            this.setInLoading(1);
            this.hideNoDataView();
            this.changeDataSource({
                newDataSource: []
            });
        }
        // 取消之前的请求
        this.abort && this.abort();

        let clientJsonObj,extMap;
        try {
            clientJsonObj = await getClientJson(this.rootStore.hyId || 'cmn_order_rn');
            extMap = await getBizVersion('hotel_rn');
            clientJsonObj.extMap = extMap;
        } catch (err) {
            clientJsonObj = {};
        }
        if(isWeb){
            clientJsonObj.type = 'touch'
        }
        // else if(isMini){
        //     clientJsonObj.type = 'weChat'
        // }
        let clientJson = JSON.stringify(clientJsonObj);
        // let clientJson = clientJsonObj

        //增加请求参数逻辑，本地订单和非本地订单请求参数有区别
        if(loadType === 'backgroundRefresh'){
            const isLogin = Boolean(await loginUtil.isLogin());
            this.setRequestParams({
                businessTypes: this.rootStore.uiState.businessValue,
                userNameQuery: isLogin,
                localQuery: !isLogin,
                unbindQuery: !isLogin,
                source: this.rootStore.uiState.sourceFrom,
            });
        }
        const requestBody = {
            limit: this.pageSize,
            start: loadType === 'backgroundRefresh'?0:this.nextStart,
            privateOrderWord: this.privateOrderWord,
            // npmOrderVer: NPM_ORDER_VERSION,// 添加NPM订单组件版本，供后端作版控使用
            clientVersion:CLIENT_VERSION,
            ...this.requestParams,
            ...this.extraRequestParams,
            clientJson
        };
        if(isWeb && getQueryParam('fromChannel')){
            requestBody.fromChannel = getQueryParam('fromChannel');
            requestBody.userNameQuery = true;
            requestBody.localQuery = false;
            requestBody.unbindQuery = false;
        }

        let cacheParam: {
            source?: any;
            limit: any;
            start?: number;
            clientJson?: string;
            userID?: any;
        };
        if (this.useCache) {
            cacheParam = {
                limit: this.pageSize,
                start: this.nextStart,
                clientJson,
                // 缓存标识里面加上用户id来区分用户
                userID: (await loginUtil.getUserInfo()).userID,
                ...this.requestParams,
                ...this.extraRequestParams
            };

            delete cacheParam.source;
            delete cacheParam.limit;
        }
        const reqStart = Date.now();
        // 订单搜索
        const orderSearchFlag = this.orderSearchFlag();
        if(orderSearchFlag){
            const searchType = this.rootStore.uiState.searchType;
            const searchKey = this.rootStore.uiState.searchKey;
            const searchTagKey = this.rootStore.uiState.searchTagKey;
            const searchBusinessValue = this.rootStore.uiState.searchBusinessValue;
            const searchOrderStatus = this.rootStore.uiState.searchOrderStatus;
            requestBody.searchType = searchType;
            requestBody.searchKey = searchKey;
            requestBody.tagKey = searchTagKey;
            requestBody.businessTypes = searchBusinessValue;
            requestBody.orderCenterStatus = searchOrderStatus;
        }
        console.log('------requestBody-------', JSON.stringify(fixRequestArgs(requestBody)))
        const orderUrl = orderSearchFlag ? URLS.searchUrl :this.url || URLS.orderlist;// searchUrl
        const requestTimeMills = new Date().getTime();
        try {
            const response = await fetch(
                {
                    url: orderUrl,
                    method: this.method,
                    body: fixRequestArgs(requestBody),
                    // requestType: 'json',
                    timeout: this.timeout
                },
                (abort: any) => {
                    if (abort) {
                        this.abort = abort;
                    }
                },
                this.rootStore.hyId
            );
            if (response && URLS.RN_ORDER_LIST === orderUrl) {
                // 结果成功返回，且是订单列表
                const networkCost = new Date().getTime() - requestTimeMills;
                PPLogUtil.logForKeyWatcher({operType: 'monitor', id: 'networkCost', time: networkCost});
            }
            console.log('-----orderlist-----',JSON.stringify(response))
            if (this.useCache && this.nextStart === 0) { //只缓存首屏请求
                orderCache.saveFirstScreenCache(this.rootStore, response);
                // await orderCache.setCache(cacheParam, response, loadType);
            }
            const fetchSuccessParams: FetchSuccessParams = {
                response,
                loadType,
                reqStart,
                reqEnd: Date.now(),
                cb,
                curStart:requestBody.start
            };
            this.fetchSuccess(fetchSuccessParams);
        } catch (err) {
            console.log('----fetchData err----',err)
            this.fetchError(err?.toString(), loadType, cb);
        } finally {
            if (loadType !== 'loadMore') {
                // 这块这么做的原因是 顶单列表 的渲染速度比 加载更多 要慢，导致页面在下拉刷新时，出现 加载更多 顶到 下拉加载 下面的情况
                this.toggleLoadmoreTimer && clearTimeout(this.toggleLoadmoreTimer);
                this.toggleLoadmoreTimer = setTimeout(() => {
                    this.toggleShowLoadMore(true);
                    this.toggleLoadmoreTimer && clearTimeout(this.toggleLoadmoreTimer);
                }, 0);
            }
            if (!this.firstLoaded) {
                this.firstLoaded = true;
            }
            this.abort = null;
        }
    };

    public  fetchError = async (
        err: string,
        loadType: string,
        cb: (arg0: { showSuc: boolean; failReason: string }) => void
    ) => {
        if (loadType === 'loadMore') {
            this.stopLoadMore(false);
        } else if (loadType === 'refresh') {
            this.stopRefresh();
        } else if (loadType === 'init') {
            this.setInLoading(0);
        }

        // 网络错误
        if (err !== 'abort') {
            if (loadType === 'loadMore') {
                // 上拉加载去掉toast提示
                // $toast({
                //     msg: `请求${err === 'timeout' ? '超时' : '失败'}，请检查网络连接!`
                // });
            } else {
                if (loadType === 'refresh') {
                    if (this.usingCacheData) {
                        toast({
                            msg: '网络不太顺畅，您访问的是缓存订单',
                            duration: 3000,
                        });
                    } else {
                        toast({
                            msg: `请求${err === 'timeout' ? '超时' : '失败'}，请检查网络连接!`
                        });
                    }

                    qav({
                        page: this.pageName,
                        module: 'apiErrorToast',
                        path: [
                            { title: err === 'timeout' ? '接口超时' : '网络错误', position: '0' }
                        ],
                        operType: 'show'
                    });
                } else {
                    // 之前代码
                    // this.showNoDataView({
                    //     redo: true,
                    //     title: '当前网络不可用',
                    //     noDataFlag: true,
                    //     redoTitle: '刷新',
                    //     isLogin: true,
                    //     img: QImageSet.noNetwork
                    // });
                    this.showNoDataView({
                        noDataFlag: true,
                        isLogin: true,
                        type: "networkFail"
                    });
                }

                cb({ showSuc: false, failReason: 'networkError' });
            }

            this.onNetworkError();
        }
    };

    @action
    public fetchSuccess = async (params: FetchSuccessParams) => {
        // console.log('fetchSuccess',JSON.stringify(params))
        const { response, loadType, reqStart, reqEnd, cb, fromCache,curStart } = params;
        const { data, status: serverStatus, message: errMessage = '' } = response;
        const { orderList, nextStart, hasMore, abSlotId, hasPrivateOrder, supportPrivateOrder} = data || {};
        this.supportPrivateOrder = supportPrivateOrder;
        let serverError = false;
        // todo web
        if((isWeb || isMini) && (serverStatus === 1004 || serverStatus === 100201) ){
            const isLogin = Boolean(await loginUtil.isLogin());
            this.setInLoading(0);
            this.showNoDataView({
                isLogin: isLogin,
                type: 'noLoginAndNoLocalOrder'
            });
            return
        }
        if (abSlotId) {
            this.abSlotId = abSlotId;
        }
        if (serverStatus !== 0 || !orderList) {
            // 以上情况为接口异常
            serverError = true;
        } else {
            this.nextStart = nextStart;
            this.hasMore = hasMore;
        }

        // 加载首屏时,清掉已记录的合单ID
        if (curStart === 0) {
            this.combinationIdAry = [];
        }

        if (orderList?.length) {
            for (let i = orderList.length - 1; i >= 0; i--) {
                const ele = orderList[i] || {};
                // TODO 特殊逻辑 **下掉电影票 公寓**
                if (['movie', 'new_apartment'].indexOf(ele.businessType) > -1) {
                    orderList.splice(i, 1);
                }
                // 机票异常数据过滤了
                if (ele.businessType === 'flight') {
                    if (!ele.flightList || !ele.flightList.length) {
                        orderList.splice(i, 1);
                    }
                }
                // console.log('page-curStart',curStart)
                // 合单 id   已经出现过的合单 去掉重复出现
                if (ele.flightMerge) {// 合单
                    if(this.combinationIdAry.indexOf(ele.combinationId) > -1){// 出现过
                        orderList.splice(i, 1);
                    }else{// 没出现过
                        this.combinationIdAry.push(ele.combinationId);
                    }
                }
            }
        }

        // 展示弹窗
        if (this.isNeedShowShakeToast && !fromCache) {
            if (loadType === 'init' && hasPrivateOrder) {
                QToast.show('已显示您的隐藏订单',  { 
                    strategy: 1, 
                    position: 0, });
                PPLogUtil.logForRelatedPrivateOrder(true)
                this.isNeedShowShakeToast = false;
            } else if (loadType === 'init' && !hasPrivateOrder && this.privateOrderWord) {
                QToast.show('无隐藏订单',  { 
                    strategy: 1, 
                    position: 0, });
                PPLogUtil.logForRelatedPrivateOrder(false)
                this.isNeedShowShakeToast = false;
            }
        }

        const result = {
            orderList,
            errMessage,
            serverError,
            serverStatus,
            response
        };
        const trainTip = '火车票订单仅保留近一个月订单';
        const defaultTip = '没有查询到相关订单';
        const isTrainList = this.requestParams.businessTypes === 'train';

        if (loadType === 'loadMore') {
            this.stopLoadMore(!serverError);
            if (serverError) {
                const loginInvaild = invalidLoginCodeMap[serverStatus];
                if (loginInvaild && this.onLoginInvalid) {
                    toast({ msg: '您的登录已失效，请重新登录' });
                    this.onLoginInvalid();
                } else {
                    // 加载更多不展示toast
                    // $toast({ msg: '服务异常，请稍后重试！' });
                }
            } else {
                this.changeDataSource({
                    newDataSource: orderList,
                    append: true
                });
            }

        }
        //新增后台偷偷刷新逻辑
        // else if(loadType === 'backgroundRefresh'){

        //     if(orderList && orderList.length > 0){
        //         this.scrollToTop && this.scrollToTop(false)//滚动到顶部
        //         setTimeout(() => {
        //             this.changeDataSource({
        //                 newDataSource: orderList,
        //                 append: false
        //             });
        //         }, 500);
        //     }
        //     cb({
        //         showSuc: !fromCache,
        //         failReason: fromCache ? 'fromCache' : '',
        //         reqStart,
        //         reqEnd
        //     });
        // }
        else {
            // 取消删除订单的请求
            this.abortDelete && this.abortDelete();

            loadType === 'refresh' && this.stopRefresh();
            loadType === 'backgroundRefresh' && this.stopRefresh();

            // 在无网，且开启缓存时，提示用户正在使用缓存
            if (!this.isNetworkConnect && this.useCache) {
                // if(loadType === 'backgroundRefresh'){

                // }else{
                    toast({
                        msg: '网络不太顺畅，您访问的是缓存订单'
                    });
                // }
            }

            const isLogin = Boolean(await loginUtil.isLogin());

            if (serverError) {
                const loginInvaild = invalidLoginCodeMap[serverStatus];

                if (loginInvaild && this.onLoginInvalid) {
                    this.onLoginInvalid();
                } else {
                    toast({ msg: '服务异常，请稍后重试！' });
                    qav({
                        page: this.pageName,
                        module: 'apiErrorToast',
                        path: [{ title: '服务异常', position: '0' }],
                        operType: 'show'
                    });
                }

                loadType === 'init' && this.setInLoading(0);

                const isNeedComment = this.rootStore.uiState.statusFilter === 'needComment';

                if (loginInvaild && isLogin){
                    this.showNoDataView({
                        isLogin: false,
                        type: isNeedComment ? "noLoginAndNoLocalOrder" : "loginInvalid"
                    });
                }
                // 未登录是待点评 tab
                else if (!isLogin && isNeedComment) {
                    this.showNoDataView({
                        isLogin: false,
                        type: 'noLoginAndNoLocalOrder'
                    });
                } else {
                    this.showNoDataView({
                        isLogin: isLogin,
                        type: "dataLoadFail"
                    });
                }

                // if(loginInvaild){
                //     alert('订单数据返回登录失效' + loginInvaild)
                // }
                if((isLogin === false || loginInvaild === true) && this.rootStore.loginOutCallBack){
                    this.rootStore.loginOutCallBack(loginInvaild)
                }
                cb({ showSuc: false, failReason: 'interfaceError' });
            } else if (!orderList.length) {
                loadType === 'init' && this.setInLoading(0);
                if(isLogin){
                    this.showNoDataView({
                        noDataFlag: true,
                        isLogin: true,
                        type: isTrainList ? "loginedNoOrderWithTrain" : "loginedNoOrder"
                    });
                } else {
                    this.showNoDataView({
                        noDataFlag: true,
                        isLogin: false,
                        type: "noLoginAndNoLocalOrder"
                    });
                }

                this.changeDataSource({
                    newDataSource: []
                });
                if(isLogin === true && this.rootStore.loginInCallBack){
                    this.rootStore.loginInCallBack()
                }
                cb({ showSuc: !fromCache, failReason: fromCache ? 'fromCache' : '' });
            } else {
                this.hideNoDataView();

                cb({
                    showSuc: !fromCache,
                    failReason: fromCache ? 'fromCache' : '',
                    reqStart,
                    reqEnd
                });
                // this.changeDataSource({
                //     newDataSource: orderList
                // });
                if(loadType === 'backgroundRefresh'){
                    if(orderList && orderList.length > 0){
                        this.scrollToTop && this.scrollToTop(false)//滚动到顶部
                        setTimeout(() => {
                            this.changeDataSource({
                                newDataSource: orderList,
                                append: false
                            });
                        }, 500);
                    }
                }else{
                    this.changeDataSource({
                        newDataSource: orderList
                    });
                }
                if(isLogin === true && this.rootStore.loginInCallBack){
                    this.rootStore.loginInCallBack()
                }
            }
        }
        this.onDataLoaded && this.onDataLoaded(loadType, result);

        // 如果是首屏加载数据,取消loading蒙层
        if (loadType === 'init') {
            this.setInLoading(0)
        }
        if (!fromCache) {
            this.usingCacheData = false;
        }
    };

    @action
    public setInLoading = (inLoading: number) => {
        if (inLoading) {
            this.inLoading++;
        } else {
            this.inLoading = this.inLoading - 1 <= 0 ? 0 : this.inLoading - 1;
        }
        // todo 未来判断其他平台小程序
        if(isMini){
            this.inLoading ? wx.showLoading() : wx.hideLoading()
        }
    };

    // 设置请求参数
    public setRequestParams = (requestParams: {}) => {
        this.requestParams = requestParams;
    };

    // 设置额外请求参数
    public setExtRequestParams = (extraRequestParams: {}) => {
        this.extraRequestParams = extraRequestParams;
    };

    @action
    public stopLoadMore = (loadmoreSuc: boolean) => {
        this.needStopLoadMore++;
        this.loadmoreSuc = loadmoreSuc;
    };

    @action
    public stopRefresh = () => {
        this.needStopRefresh++;
    };

    // 开启/关闭，删除功能
    @action
    public toggleDeleteable = (enableDelete: boolean) => {
        this.enableDelete = enableDelete;
    };

    @action
    public toggleShowBackToTop = (showBackToTop: any) => {
        this.showBackToTop = showBackToTop;
    };

    // NoData 组件专属属性

    // 展示无数据蒙版
    @action
    public showNoDataView = (params: ShowNoDataViewParams) => {
        const {
            isLogin,
            noDataFlag = false,
            type
        } = params;
        this.isLogin = isLogin;
        this.type = type;
        this.noDataFlag = noDataFlag;
        this.showNoData = true;
        if (!(isLogin || !noDataFlag)) {
            qav({
                page: this.pageName,
                module: 'loginBtn',
                path: [{ title: '登录', position: '0' }],
                operType: 'show'
            });
        }

        // 展示无数据/网络错误页面时,隐藏更多按钮弹窗
        this.rootStore.moreButtonStore && this.rootStore.moreButtonStore.hiddenMoreButtonList();
    };

    // 隐藏无数据蒙版
    @action
    public hideNoDataView = () => {
        this.showNoData = false;
        this.noDataFlag = false;
        this.type = "none";
    };

    public onOrderItemPress = (
        detailAction: {
            isSchema?: boolean;
            schema?: string;
            url?: string;
            detailHint?: string;
            title?: string;
        } = {},
        businessType: any,
        sysCode: any,
        orderNo: any,
        orderCellIndex: number,
        isPrivate: boolean,
    ) => {
        // TODO
        // if (
        //     dataset.ondelete === 'true'
        //     || isScrolling
        //     || sleepOrderItemClick.isSleep(this.name)
        // ) {
        //     return;
        // }
        const { isSchema, schema, detailHint, title } = detailAction;
        let { url } = detailAction;
        if(isMini){
            url = fixWxOrderUrl(url)
        }
        if (schema || url) {
            // 跳走后，可能会在之后的页面切换登录态
            this.rootStore.needCompareLogin = true;
            this.rootStore.uiState.isBackFromOrderDetail = true
            this.isBackFromPrivateOrder = isPrivate;
            this.sysCode = sysCode;
            this.orderNo = orderNo;
            this.orderCellIndex = orderCellIndex;
            // TODO 由于框架ext路由跳转没有上报错误，这里暂时只能直接使用wx的api
            if(isMini){
                wx.navigateTo({
                    url,
                    fail: () => {
                        toast({
                            msg: '请前往去哪儿APP查看此订单详情'
                        });
                    }
                })
            }else{
                navigate({
                    isSchema,
                    schema,
                    url
                });
            }
            
            qav({
                page: this.pageName,
                module: 'orderDetailBtn',
                path: [
                    {
                        title,
                        position: 0,
                        ext: {
                            businessType,
                            jumpSuc: true
                        }
                    }
                ],
                operType: 'click',
                source:this.rootStore.uiState.sourceFrom,
            });

            PPLogUtil.logForKeyWatcher({ operType: OPER_CLICK, id: 'detail', ext: { orderNo, scheme: isSchema ? schema : url } });

        } else {
            const msg = detailHint || (DeviceInfo.isNotRn ? '请前往去哪儿APP查看此订单详情' : '查看订单详情失败,请刷新页面重试')
            toast({
                msg
            });
            qav({
                page: this.pageName,
                module: 'orderDetailBtn',
                path: [
                    {
                        title,
                        position: 0,
                        ext: {
                            businessType,
                            jumpSuc: false
                        }
                    }
                ],
                operType: 'click',
                source:this.rootStore.uiState.sourceFrom,
            });
    
            const orderItem = this.originDataSource?.find((item) => orderNo === item.orderNo);
            PPLogUtil.logForKeyWatcher({operType: 'monitor', id: 'detailFail', ext: {orderNo, sysCode, businessType, item: orderItem}});
        }
    };

    public onOrderBtnPress = (
        actionInfo: {
            isSchema: any;
            url: any;
            schema: any;
            actionType: any;
            phone: any;
            title: any;
            actionName: any;
        },
        businessType: any,
        index: any,
        sysCode: any,
        orderNo: any,
        orderCellIndex: number,
        isPrivate: boolean,
    ) => {
        const { isSchema, schema, actionType, phone, title, actionName } = actionInfo;
        let { url } = actionInfo;
        if(isMini){
            url = fixWxOrderUrl(url)
        }
        if (actionType === 'openview') {

            // 去点评回来刷新页面
            if (actionName && actionName.toLowerCase() === 'comment') {
                this.rootStore.needRefresh = true;
            }
            // 跳走后，可能会在之后的页面切换登录态
            this.rootStore.needCompareLogin = true;
            this.rootStore.uiState.isBackFromOrderDetail = true
            this.isBackFromPrivateOrder = isPrivate;
            this.sysCode = sysCode;
            this.orderNo = orderNo;
            this.orderCellIndex = orderCellIndex;
            navigate({
                isSchema,
                url,
                schema
            });

        } else if (actionType === 'phonecall') {
            Communications.phonecall(phone, true);
        }
        qav({
            page: this.pageName,
            module: 'orderBtn',
            path: [
                {
                    title,
                    position: index,
                    ext: {
                        businessType
                    }
                }
            ],
            operType: 'click',
            source:this.rootStore.uiState.sourceFrom,
        });
        // alert('点击订单按钮')
        // 点击支付watcher埋点
        if (actionName === 'pay') {
            PPLogUtil.logForKeyWatcher({
                id: 'pay',
                operType: 'click',
                ext: {
                    orderNo,
                    scheme: schema
                }
            });
        }
        
    };

    public hidePrivacyOrder(){
        if (this.privateOrderWord) {
            this.originDataSource = this.originDataSource.filter(item=>{return item.private !== true});
            this.dataSource = this.originDataSource;
            this.privateOrderWord = '';
            if (this.dataSource.length === 0) {
                this.showNoDataView({
                    noDataFlag: true,
                    isLogin: true, 
                    type: "loginedNoOrder"
                });
        }
        }
    }

    // 请求更新特定item
    public async requestUpdateOrderItem(){

        if(this.orderNo.length  <= 0 || this.sysCode.length <= 0){
            return
        }

        if (this.isBackFromPrivateOrder) {
            this.scrollTopAndInit(false);
            this.isBackFromPrivateOrder = false;
            return;
        }


        const requestBody = {
            limit: this.pageSize,
            // start: loadType === 'backgroundRefresh'?0:this.nextStart,
            start: 0,
            ...this.requestParams,
            ...this.extraRequestParams,
            orderNo:this.orderNo,
            sysCode:this.sysCode,
            orderNoQuery:true,
        };
        // 订单搜索
        const orderSearchFlag = this.orderSearchFlag();
        if(orderSearchFlag){
            const searchType = this.rootStore.uiState.searchType;
            const searchKey = this.rootStore.uiState.searchKey;
            const searchTagKey = this.rootStore.uiState.searchTagKey;
            const searchBusinessValue = this.rootStore.uiState.searchBusinessValue;
            const searchOrderStatus = this.rootStore.uiState.searchOrderStatus;
            requestBody.searchType = searchType;
            requestBody.searchKey = searchKey;
            requestBody.tagKey = searchTagKey;
            requestBody.businessTypes = searchBusinessValue;
            requestBody.orderCenterStatus = searchOrderStatus;
        }
        // console.log('------requestUpdateOrderItem-------', fixRequestArgs(requestBody))
        const orderUrl = orderSearchFlag ? URLS.searchUrl :this.url || URLS.orderlist;// searchUrl
        try {
            const response = await fetch(
                {
                    url: orderUrl,
                    method: this.method,
                    body: fixRequestArgs(requestBody),
                    requestType: 'form',
                    timeout: this.timeout
                },
                (abort: any) => {

                },
                this.rootStore.hyId
            );
            // console.log('orderlist=111111',JSON.stringify(response))
            if(response.status === 0){
                // orderCellIndex
                if(response.data && response.data.orderList && response.data.orderList.length > 0){
                    if(this.orderCellIndex >= 0 && this.originDataSource.length > this.orderCellIndex){
                        // let item = this.originDataSource[this.orderCellIndex]
                        // if(item.orderNo === this.orderNo && item.sysCode === this.sysCode && response.data.orderList[0].orderNo === this.orderNo){
                        //     this.originDataSource[this.orderCellIndex] = response.data.orderList[0]
                        //     this.dataSource = this.originDataSource.slice();
                        // }

                        let itemToReplace = this.originDataSource.find(item => (item?.orderNo === response.data.orderList[0].orderNo  && item?.sysCode === response.data.orderList[0].sysCode));
                        if (itemToReplace) {
                            let index = this.originDataSource.indexOf(itemToReplace);
                            this.originDataSource[index] = response.data.orderList[0];
                            this.dataSource = this.originDataSource.slice();
                        }
                        // 临时测试***
                        // if(item.orderNo === this.orderNo){
                        //     // this.originDataSource[4].statusDesc = '临时测试1111111111'
                        //     this.originDataSource[this.orderCellIndex] = response.data.orderList[0]
                        //     this.dataSource = this.originDataSource.slice();
                        // }
                    }
                }else{
                    // if(this.orderCellIndex >= 0 && this.originDataSource.length > this.orderCellIndex){
                    //     let item = this.originDataSource[this.orderCellIndex]
                    //     if(item.orderNo === this.orderNo && item.sysCode === this.sysCode){
                    //         this.originDataSource.splice(this.orderCellIndex, 1);
                    //         this.dataSource = this.originDataSource.slice();
                    //     }
                    // }
                    // 如果后端返回了一个空列表,需要通过syscode和orderNo找到要刷新的订单,进行移除
                    let itemToRemove = this.originDataSource.find(item => (item?.orderNo === this.orderNo  && item?.sysCode === this.sysCode));
                    if (itemToRemove) {
                        this.originDataSource = this.originDataSource.filter(item=>(item !== itemToRemove));
                        this.dataSource = this.originDataSource.slice();
                    }
                    if (this.dataSource.length === 0) {
                        this.showNoDataView({
                            noDataFlag: true,
                            isLogin: true, 
                            type: "loginedNoOrder"
                        });
                    }        

                }
            }
            this.orderNo = ''
            this.sysCode = ''
            this.orderCellIndex = -1
        } catch (err) {
            this.orderNo = ''
            this.sysCode = ''
            this.orderCellIndex = -1
        }
         // setTimeout(() => {
        //     this.originDataSource[4].statusDesc = '临时测试1111111111'
        //     this.dataSource = this.originDataSource.slice();
        //     console.log('^^^^^^&&&&&'+JSON.stringify(this.dataSource))
        // }, 1000);
    }

    // this.rootStore.uiState.statusFilter

    // 订单搜索的结果展示模式
    @action
    public orderSearchFlag = (sourceFrom:any) => {
        sourceFrom = sourceFrom || this.rootStore.uiState.sourceFrom;
        return sourceFrom == 'search';
    }

    // 是否显示 订单搜索入口
    @action
    public orderSearchEntry = () => {
        // isIOS || isAndroid 只考虑app内
        const dataType = this.type;//数据状态
        const curBusinessId = this.rootStore.uiState.businessId;//carcar -> car,icar
        // const businessValue = this.rootStore.uiState.businessValue;//carcar -> car,icar
        const sourceFrom = this.rootStore.uiState.sourceFrom;// journey
        // const curStatusId = this.rootStore.uiState.statusFilter;//订单状态
        // console.log('orderSearchEntry',dataType,curBusinessId,sourceFrom)
        // console.log('businessValue',businessValue)
        return (isIOS || isAndroid)
                && (dataType !=='noLoginAndNoLocalOrder') //未登录-无数据
                // && (curBusinessId == 'all') // 业务线-全部
                && (sourceFrom == 'journey' || sourceFrom == 'mine');// commonbusiness_rn进来 
    };

    @action
    public privateCofirmCallback = (privateVisible: boolean,callback:any) => {
        if(this.privateCallback){
            this.privateCallback();
        }
    };

    @action
    public privateCofirmVisible = (privateVisible: boolean,callback:any) => {
        this.privateVisible = privateVisible;
        if(callback){
            this.privateCallback = callback;
        }
    };

    @action
    public toggleShowLoadMore = (showLoadMore: boolean) => {
        this.showLoadMore = showLoadMore;
    };

    // 点击按钮，要删除订单
    @action
    public onOrderDeletePress = (deleteInfo: { canDelete: boolean; deleteTip: string }) => {
        if (deleteInfo.canDelete) {
            this.deleteInfo = deleteInfo;
            this.cofirmVisible = true;
        } else {
            this.alertTitle = deleteInfo.deleteTip;
            this.alertVisible = true;
        }
        qav({
            page: this.pageName,
            module: 'deleteOrderBtn',
            path: [
                {
                    title: '删除',
                    position: 0,
                    ext: {
                        deleteEnable: deleteInfo.canDelete
                    }
                }
            ],
            operType: 'click'
        });
    };

    // 点击弹窗的取消按钮
    @action
    public onAlertClose = () => {
        this.alertVisible = false;
    };

    // 确认删除订单
    @action
    public onDeleteConfirmOk = () => {
        if (!this.deleteInfo) {
            return;
        }

        this.deleteOrder();

        this.cofirmVisible = false;
        qav({
            page: this.pageName,
            module: 'deleteOrderAlertBtn',
            path: [
                {
                    title: '确认删除',
                    position: 0,
                    ext: {}
                }
            ],
            operType: 'click'
        });
    };

    // 点错了，不想删除订单
    @action
    public onDeleteConfirmCancel = () => {
        this.deleteInfo = null;

        this.cofirmVisible = false;
    };

    // 删除订单可能是删除普通订单和删除共享订单
    public deleteOrder = async () => {
        const { isShare, sysCode, orderNo } = this.deleteInfo;
        if (sysCode && orderNo) {
            this.abortDelete && this.abortDelete();
            this.setInLoading(1);

            try {
                const response = await fetch(
                    {
                        url: isShare ? URLS.cancelShare : URLS.deleteOrder,
                        method: 'POST',
                        body: isShare
                            ? {
                                  sysCode,
                                  orderNo
                              }
                            : {
                                  data: JSON.stringify([
                                      {
                                          sysCode,
                                          orderNo
                                      }
                                  ])
                              },
                        requestType: 'form',
                        timeout: 20000
                    },
                    (abort: any) => {
                        if (abort) {
                            this.abortDelete = abort;
                        }
                    },
                    this.rootStore.hyId
                );
                const { status, data } = response;
                if (
                    (isShare && status === 0 && data === true) ||
                    (!isShare && status === 0 && data && data[0] && data[0].status === 1)
                ) {
                    // TODO 缓慢删除动画
                    // this.slowHidden();

                    //删除订单
                    const newDataSource = this.originDataSource.slice().filter((item) => {
                        if(item.flightMerge){
                            item.listData = item.listData.slice().filter((v:any) => (v.orderNo !== orderNo));
                        }
                        return item.orderNo !== orderNo;
                    })
                    this.changeDataSource({
                        newDataSource
                    });
                    let cacheParam;
                    if (this.useCache) {
                        let clientJson,extMap;
                        try {
                            clientJson = await getClientJson(this.rootStore.hyId || 'cmn_order_rn');
                            extMap = await getBizVersion('hotel_rn');
                            clientJson.extMap = extMap;
                            clientJson = JSON.stringify(clientJson);
                        } catch (err) {
                            clientJson = JSON.stringify({});
                        }
                        cacheParam = {
                            limit: this.pageSize,
                            start: this.nextStart,
                            clientJson,
                            // 缓存标识里面加上用户id来区分用户
                            userID: (await loginUtil.getUserInfo()).userID,
                            ...this.requestParams,
                            ...this.extraRequestParams
                        };

                        delete cacheParam.source;
                        delete cacheParam.limit;
                        await orderCache.deleteOrder(cacheParam, sysCode, orderNo);
                    }

                    /* 防止 cache 异步删除导致刷新后订单重新展示 */
                    runInAction(() => {
                        // 删除之后，页面没有订单了，刷新页面
                        if (!this.originDataSource.length) {
                            this.scrollTopAndInit();
                        }
                    });
                    qav({
                        page: this.pageName,
                        module: 'deleteOrderResult',
                        path: [
                            {
                                title: '删除结果',
                                position: 0,
                                ext: {
                                    deleteSuc: true
                                }
                            }
                        ],
                        operType: 'click'
                    });
                } else {
                    qav({
                        page: this.pageName,
                        module: 'deleteOrderResult',
                        path: [
                            {
                                title: '删除结果',
                                position: 0,
                                ext: {
                                    deleteSuc: false
                                }
                            }
                        ],
                        operType: 'click'
                    });
                    // 如果是未登录，则全局处理
                    if (status && invalidLoginCodeMap[status]) {
                        return;
                    }
                    toast({
                        msg: '订单删除失败，请重试!'
                    });
                }
            } catch (err) {
                qav({
                    page: this.pageName,
                    module: 'deleteOrderResult',
                    path: [
                        {
                            title: '删除结果',
                            position: 0,
                            ext: {
                                deleteSuc: false
                            }
                        }
                    ],
                    operType: 'click'
                });
                toast({
                    msg: `请求${err === 'timeout' ? '超时' : '失败'}，请检查网络连接!`
                });
            } finally {
                this.abortDelete = null;
                this.setInLoading(0);
                this.deleteInfo = null;
            }
        }
    };

    public clearRedPoint = async (sysCode: number, orderNo: string) => {
        let clientJson, extMap;
        try {
            clientJson = await getClientJson(this.rootStore.hyId || 'cmn_order_rn');
            extMap = await getBizVersion('hotel_rn');
            clientJson.extMap = extMap;
        } catch (err) {
            clientJson = {};
        }

        const dataToCleare = {
            sysCode,
            orderNo
        }

        const body = {
            type: 1,
            clientJson,
            data: dataToCleare
        }

        try {
            await f(
                {
                    url: URLS.clearServiceRedPoint,
                    method: 'POST',
                    body
                }
            );
        } catch (error) {
            // alert(error);
        }
    }
}

function fixRequestArgs(args: { [x: string]: any; limit?: number; start?: number }) {
    const newArgs: { [propName: string]: any } = {};

    Object.keys(args).forEach((key) => {
        const value = args[key];

        if (value !== undefined || value !== '') {
            newArgs[key] = value;
        }
    });

    return newArgs;
}

interface FetchSuccessParams {
    response: any;
    loadType: string;
    reqStart?: number;
    reqEnd?: number;
    fromCache?: boolean;
    cb?: (arg0: {
        showSuc: boolean;
        failReason: string;
        reqStart?: number;
        reqEnd?: number;
    }) => void;
    curStart:number
}
interface ShowNoDataViewParams {
    isLogin: boolean;
    noDataFlag?: boolean;
    type: NoDataTypes;
}
